<template>
<div>
<v-timeline  >
  <template v-for='message in allMessages' >
    <v-timeline-item small
      :key='message.id'
      :right='message.sender_type === "practitioner"'
      :left='message.sender_type === "client"' >
      <span slot="opposite">
        {{message.sender_email}}<br/>
        <small>{{ dateformat(message.created, 'ddd, MMM Do YYYY, h:mm a') }}</small>
      </span>
      <v-alert :value='true' dense outline class='ma-2 rounded-lg' >
        {{message.body}}<br/>
        <v-chip outline outlined
          v-if='message.exercise_name'
          class='v-chip--x-small ml-0' >{{message.exercise_name}}</v-chip>
        <v-chip outline outlined color='error'
          v-if='message.exercise_name'
          class='v-chip--x-small ml-0' >
          Pain: {{message.pain_level}}</v-chip>
        <v-progress-circular
          v-if='message.persisted===false'
          size='12' indeterminate width='1' color='amber' style='float:right;' ></v-progress-circular>
      </v-alert>
    </v-timeline-item>
  </template>
</v-timeline>
<v-textarea outline outlined auto-grow persistent-hint
  :rows="1"
  v-model='message'
  @keypress.enter.stop='send'
  @click:append='send'
  @click:prepend='t'
  :error-messages='sendErrors'
  label='Send message'
  append-icon='send'
  prepend-icon='replay'
  hint='Press enter to send (shift-enter for a new line)'
  class='mx-2'  >
</v-textarea>
</div>
</template>
<script>
export default {
  name: 'PhysiMessages',
  props: {
    physitrackClientId: { required: true },
    messages: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      message: '',
      sendRequest: {
        resource: 'ag.integrations',
        extra: 'physitrack/sendmessage'
      },
      newMessages: []
    }
  },
  watch: {
    sendStatus () {
      if (this.sendStatus === 201) {
        this.$emit('new')
      }
    },
    messages () {
      this.newMessages = []
    }
  },
  computed: {
    allMessages () {
      return this.messages.concat(this.newMessages)
    },
    sendStatus () {
      return this.sendRequest.status
    },
    sendErrors () {
      if (this.sendStatus === 422) {
        console.log(this.sendRequest.errors)
        return this.getObjectPath(this.sendRequest, 'errors.errors', [])
      }
      return []
    }
  },
  methods: {
    t () {
      this.$emit('new')
    },
    send (e) {
      if (e && e.shiftKey === true) { return null }
      let message = {
        sender_type: 'practitioner',
        body: this.message,
        persisted: false
      }
      this.newMessages.push(message)
      this.sendRequest.data = {
        client_id: this.physitrackClientId,
        message: this.message
      }
      this.$request('save', this.sendRequest)
      // window.alert('sending ' + this.message)
    }
  }
}
</script>
<style scoped>
.rounded-lg {
  border-radius: 8px!important;
}
</style>



// WEBPACK FOOTER //
// Messages.vue?d5d9961e